import type {ReactElement} from 'react';
import type {AiChatCapability, AiChatCapabilityGroup} from '@AiChat/ai-chat.types';
import type {AiChatQuickTipsCapabilitiesProps} from './ai-chat-quick-tips-capabilities.types';
import styles from './ai-chat-quick-tips-capabilities.module.scss';
import {Text, TextSize, TextTag} from '@Components/text';
import {AiChatQuickTipsItemHeaderIcon} from '@AiChat/components/ai-chat-quick-tips/components/ai-chat-quick-tips-item-header-icon/ai-chat-quick-tips-item-header-icon';

export function AiChatQuickTipsCapabilities({headingKey, capabilityGroups}: AiChatQuickTipsCapabilitiesProps): ReactElement {
  const renderCapability = (capability: AiChatCapability): ReactElement => (
    <li key={capability.nameKey} className={styles.capability}>
      <Text size={TextSize.MD} bold val={window.i18next.t(capability.nameKey)} />
      <Text size={TextSize.MD} className={styles.capabilityDescription} val={window.i18next.t(capability.descriptionKey)} />
    </li>
  );

  const renderCapabilityGroup = (capabilityGroup: AiChatCapabilityGroup): ReactElement => (
    <div key={capabilityGroup.headingKey} className={'bg-neutral-0 border-s-standard radius-12 spacing-p-4 flex-v-row gap-4'}>
      <div className={styles.groupHeader}>
        <AiChatQuickTipsItemHeaderIcon icon={capabilityGroup.icon} />
        <Text tag={TextTag.H4} size={TextSize.LG} bold className={styles.groupHeading} val={window.i18next.t(capabilityGroup.headingKey)} />
      </div>
      <ul className={styles.capabilityList}>{capabilityGroup.capabilities.map(renderCapability)}</ul>
    </div>
  );

  return (
    <section className={'flex-v-row gap-3'}>
      <Text tag={TextTag.H3} size={TextSize.MEDIUM} bold className={styles.heading} val={window.i18next.t(headingKey)} />
      <div className={styles.capabilityGroups}>{capabilityGroups.map(renderCapabilityGroup)}</div>
    </section>
  );
}
